export interface DevicePhoneTab<TabId extends string> {
  id: TabId;
  label: string;
  // Брояч до раздела (напр. избрани акаунти); без него — само етикетът.
  count?: string;
  // Цветът на брояча, когато разделът е избран.
  countClassName: string;
}

interface Props<TabId extends string> {
  tabs: DevicePhoneTab<TabId>[];
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

/**
 * Превключвателят на разделите под хедъра на телефон — секциите на
 * устройството са отделни раздели, за да не се трупат една под друга.
 */
const DevicePhoneTabs = <TabId extends string>({ tabs, activeTab, onTabChange }: Props<TabId>) => (
  <div className="shrink-0 border-b border-shade-2 bg-surface px-3 pb-2.5">
    <div
      role="tablist"
      className="grid gap-1 rounded-[12px] bg-fill-2 p-1"
      // Броят на разделите идва от извикващия (2 или 3).
      style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={`flex h-10 min-w-0 cursor-pointer items-center justify-center gap-1.5 rounded-[9px] px-2 text-[14px] font-bold transition-colors ${
              isActive
                ? "bg-surface text-ink shadow-[0_1px_3px_rgba(17,17,17,0.12)]"
                : "text-body"
            }`}
          >
            <span className="truncate">{tab.label}</span>
            {tab.count !== undefined && (
              <span
                className={`shrink-0 rounded-full px-[7px] py-px text-[11.5px] font-bold ${
                  isActive ? tab.countClassName : "bg-shade-2 text-body"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default DevicePhoneTabs;
